import { GridColDef } from '@mui/x-data-grid/models/colDef/gridColDef';
import { ICityItem } from 'types';
import { CITIES_HEADER_TITLES } from 'utils/constants/cities-table';
import { CITIES_FIELDS_NAME } from 'utils/enums';

export interface ICityTableRow extends ICityItem {
	'region.name': string;
}

export const COLUMNS_CONFIG: GridColDef<ICityTableRow>[] = [
	{ field: CITIES_FIELDS_NAME.ID, headerName: CITIES_HEADER_TITLES.ID, flex: 0.7, minWidth: 120 },
	{ field: CITIES_FIELDS_NAME.NAME, headerName: CITIES_HEADER_TITLES.NAME, flex: 1, minWidth: 180 },
	{ field: CITIES_FIELDS_NAME.PREFIX, headerName: CITIES_HEADER_TITLES.PREFIX, flex: 1, minWidth: 160 },
	{ field: CITIES_FIELDS_NAME.SHOR_PREFIX, headerName: CITIES_HEADER_TITLES.SHOR_PREFIX, flex: 1, minWidth: 160 },
	{ field: CITIES_FIELDS_NAME.REGION_ID, headerName: CITIES_HEADER_TITLES.REGION_ID, flex: 1.4, minWidth: 220 },
	{ field: CITIES_FIELDS_NAME.REGION_NAME, headerName: CITIES_HEADER_TITLES.REGION_NAME, flex: 1.2, minWidth: 220 },
];
